import { connect } from 'react-redux';
import Popup from 'components/Popup';
import { selectSelectedFeature, selectPopupId } from 'modules/map';

export default connect(
  state => ({
    feature: selectSelectedFeature(state),
    popupId: selectPopupId(state),
  }),
  null,
)(Popup);
